import React, { useState, useEffect, useContext } from 'react';

import * as net from "../lib/net";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import Dd_Sel from "../lib/ui/dd_sel";
import {withRouter} from "../lib/react/withRouter";
//import crypto from "crypto-js";

import sso from "../sso.js";

function web01() {

    var html =
    <div className="">
        Test
    </div>
    ;
    return html;
}

class Home extends React.Component {
    //var sdo = useContext(SDOContext); // Functional
    //static contextType = SDOContext; // Class

    constructor(props, context) {
        super(props);

        this.s1ref = React.createRef();
        this.s2ref = React.createRef();

        this.webStore = props.store;
        this.state = { pgid: 11, stat: [] };
        this.state.open = false;
        this.state.seldate = new Date();
        this.state.row = null;
        this.state.info = "";
        this.state.top = 1;

        this.state.user = {};
        this.state.sdo = {};

        this.state.step = 1;
    }
    componentDidMount(){
        var mws_usr = localStorage.getItem("mws_usr");
        if(mws_usr) {
            mws_usr = JSON.parse(mws_usr);
            //alert(JSON.stringify(mws_usr));
            this.setState({ user: mws_usr });
        }
    }

    componentWillUnmount(){
            this.setState({info: "UUU" });
    }

   header_css() {
  	    var css = {};
		if(this.state.top) {
			css.color = "#fff";
			css.background = "transparent";
			css.height = "50px";
			//css["background"] = "green";
		}
		else {
			css.color = "#000";
			css.background = "#fff";
		    css.height = "50px";
        }

		return css;
    }
    header_class() {
  	    var cls = "flex_col";
		if(this.state.top) {
			cls = cls + " web-head-1";
		}
		else cls = cls +  " web-header";

		return cls;
    }

    cdi_show(id) {
        //alert(id);
        var brc = false;
        if(this.state.step == id) brc = true;
        return brc;
    }

    mnu_sel(mnuid) {

        this.setState({mnu_sel: mnuid});
        const element = document.getElementById(mnuid);
        if (element) element.scrollIntoView();
    }

   mnu_item_css(mnuid) {
  	    var css = {};

        css.color = "#222";
        if(this.state.mnu_sel == mnuid) {
			///css.background = "#080";
			//css.color = "#fff";
			css.color = "#080";
        }
		return css;
    }

    row_css(row) {
  	    var css = {};
		if(this.state.row) {
		if(this.state.row.ank == row.ank) {
			css.background = "#080";
			css.color = "#fff";
		}
		}
		return css;
    }
    login() {
        this.setState({login: true });
        //this.props.history.push("pos");
    }
    handleUserInput (e) {
      const name = e.target.name;
      const value = e.target.value;
      var user = this.state.user;
      user[name] = value;
      this.setState({ user: user });
      //setState({[name]: value});
    }
    handleLogin(event) {
        //this.setState({value: event.target.value});
        //const body = new FormData(this.form);
        //alert('FORM: ' + JSON.stringify(state));
        //props.ctx.dologin(state.user.uid, state.user.pwd);
        this.login_srv(this.state.user.uid, this.state.user.pwd);
    }
	handleClose = () => {
		//this.props.ctx.setState({ login: false });
	};
    login_srv(uid, pwd) {
        var self = this;
		var prm = {};
		prm.req = "usr:login";
		prm.uid = uid;
		prm.pwd = pwd;
		prm.token = "";

		//alert(JSON.stringify(prm));
        //gda.wndLoading("Hämtar");
        net.gcs_req(prm)
        .then(function(ret){
            //alert(JSON.stringify(ret));

            if(ret.ok != "000") {
                alert(JSON.stringify(ret));
                return;
            }
            //alert(JSON.stringify(ret.seo));

            var seo = ret.seo;
            //alert(JSON.stringify(seo));

            var mws_usr = {};
            mws_usr.uid = uid;
            mws_usr.pwd = pwd;
            localStorage.setItem("mws_usr", JSON.stringify(mws_usr));
            //var bytes = crypto.AES.decrypt(res.data, key);
            //var cds = bytes.toString(crypto.enc.Utf8);

            var xdo = JSON.stringify(seo);
            sessionStorage.setItem("svp", xdo);
            self.props.store.seo = seo;

            var seo = ret.seo;
            //var keys = Object.keys(seo);
            //alert(JSON.stringify(seo));
            //for(var key of keys) {
            //    sso.seo[key] = seo[key];
            //}
            //sso.seo = seo;
            
            var url = seo.auto;
            if(url == "casino.ov") url = "cas.ov";
            url = "/" + url.replace(/\./g,"/");
            if(false) url = "/pos";

            //alert(JSON.stringify(url));
            self.props.navigate(url);
            window.location.reload(true);
        })
        .catch(function(e){
            //var txt = JSON.stringify(e);
            alert("LOGIN ERR: " + JSON.stringify(e));
            //gda.wndError(txt);
        });
    }
    fknGo(url) {
        this.props.navigate(url);
   };

    render() {
        var stat = [];
        var keys = Object.keys(this.state.stat);
        for (var key of keys) {
            var row = this.state.stat[key];
            stat.push(row);
        }
        const handleDateChange = date => {
            this.setState({seldate: date });
        };

        return (
        <div className="web-app">

            <div id="header" className={ this.header_class() }>
            <div className="web-top-content d-flex flex-row">
                <div className="hide px-3 grey-text" onClick={() => this.ham_show() }>
                    <FontAwesomeIcon icon="bars" size="lg" color="grey" />
                </div>
                <h5 className="px-2 py-2">SPAIDER</h5>
                <div className="flex-fill"></div>

                <h5 className="px-2 py-2">LOGIN</h5>
                <div className="">
                    <Dd_Sel items={ this.selitems } cls="web-top-icon" getValue={(e)=> this.sel_fkn(e)} />
                </div>
            </div>
            </div>


    <div className="web-body flex-col">

                    <div className="flex-row justify-content-center">
                    <img className="cdi-logo" src={require('./img/logo-spaider.png')} />
                    </div>
 
                    <div className="flex-row justify-content-center">
                    <div className="">
                            <div className="">
                                    <div className="login_header text-center mb-lg-5 mb-4">
                                        <h3 className="login__title mb-2"> Inloggning</h3>
                                        <p>Välkommen!</p>
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="exampleInputEmail1" className="input__label">Username</label>
                                        <input type="text" className="form-control login_text_field_bg input-style flex"
                                               id="uid" aria-describedby="emailHelp" placeholder=""
                                               required=""
                                               name="uid" value={this.state.user.uid} onChange={(event) => this.handleUserInput(event)}
                                               autoFocus />
                                    </div>
                                    <div className="form-group">
                                        <label htmlFor="exampleInputPassword1" className="input__label">Password</label>
                                        <input type="password" className="form-control login_text_field_bg input-style flex" id="pwd" name="pwd" value={this.state.user.pwd} onChange={(event) => this.handleUserInput(event)} placeholder="" required />
                                    </div>
                                    <div className="hide form-check check-remember check-me-out">
                                        <input type="checkbox" className="form-check-input checkbox" id="exampleCheck1" />
                                            <label className="form-check-label checkmark" htmlFor="exampleCheck1">
                                                Remember me
                                            </label>
                                    </div>
                                    <div className="flex-row justify-content-center">
                                        <button onClick={(event) => this.handleLogin(event) } className="btn btn-primary btn-style mt-4 w250">
                                            Logga in
                                        </button>
                                    </div>
                                    <div className="d-flex align-items-center flex-wrap justify-content-between">
                                    <div className="hide" onClick={(event) => this.fknGo("/signup") }>
                                        Don’t have an account?
                                        <div className="back">Sign up</div>
                                    </div>
                                    </div>
                                <div className="hide backtohome mt-4">
                                    <div className="back" onClick={(event) => this.fknGo("/hka") }>
                                        <i className="fa fa-chevron-left" aria-hidden="true"></i>
                                        Back to Home
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                <div className="flex"></div>
                <div className="flex-cc py-5">
                <div className="txt-18">Ny uppdatering 2025-04-22</div>
                </div>
        </div>
        </div>
        );
    }
}

//WebPub.contextType = SDOContext; // Function
export default withRouter(Home);